import script from "./NotCreatedPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotCreatedPage.vue?vue&type=script&lang=ts&setup=true"

import "./NotCreatedPage.vue?vue&type=style&index=0&id=2f20463b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f20463b"]])

export default __exports__